import React from "react";
import Chart from "react-apexcharts";
import useConfig from "../../../Hooks/useConfig";

export default function Charts({ data }) {
    const {hover_type} = useConfig();
    const categories = data?.map((item) => item.name);
    const ticketSeries = data?.map((item) => item.ticket_count);
    const daysSeries = data?.map((item) => item.time);

    const state = {
        series: [
            {
                name: "Tickets Closed",
                data: ticketSeries,
            },
        ],
        options: {
            chart: {
                type: "bar",
                height: 350,
                toolbar: { show: false },
            },
            colors: ["var(--primary-color)"],
            states: {
                hover: {
                    filter: {
                        type: hover_type
                    }
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 5,
                    dataLabels: {
                        position: "top",
                    },
                },
            },
            dataLabels: {
                enabled: true,
                formatter: function (_val, opts) {
                    const item = data[opts.dataPointIndex];
                    return [
                        `${item.ticket_count} Tickets `,
                        `${item.time} ${item.time > 1 ? "Days" : "Day"}`
                    ];
                },
                textAnchor: 'middle',   // or 'start' for left-align
                offsetY: -32,
                style: { fontSize: '12px', colors: ['#000'] },
                background: { enabled: false } // set true if you want a pill behind text
            },
            xaxis: {
                categories: categories,
                title: { text: "Technicians" },
            },
            yaxis: {
                title: { text: "Tickets Closed" },
            },
            tooltip: {
                marker: {
                    show: false,
                },
                y: {
                    title: {
                        formatter: () => ''
                    },
                    formatter: function (val, opts) {
                        const item = data[opts.dataPointIndex];
                        return (
                            `Tickets Closed : ${item.ticket_count}<br/>` +
                            `Closure Time : ${item.time} ${item.time > 1 ? "Days" : "Day"}`
                        );
                    },
                },
            },
        },
    };

    return (
        <div style={{ width: "100%" }} className="pt-4">
            <Chart
                options={state.options}
                series={state.series}
                type="bar"
                height={350}
            />
        </div>
    );
}



